import styled from "styled-components"
import DonateBanner from "../blocks/DonateBanner"
import CarePackage from "../blocks/CarePackages"
import DonationLinks from "../blocks/DonationLinks"
import Footer from "../blocks/Footer"

const StyledDonate = styled.div`
  background-color: var(--gray-50);
  color: var(--gray-800);
  font-family: 'Gilroy', sans-serif;
`

const FooterContainer = styled.div`
  background-color: var(--dark-green);
`

const Donate = () => {
  return (
    <StyledDonate>
      <DonateBanner/>
      <CarePackage/>
      <DonationLinks/>
      <FooterContainer>
        <Footer/>
      </FooterContainer>
    </StyledDonate>
  )
}

export default Donate